// Component: Badge.jsx
// Purpose: DS Badge primitive — tinted status/label pill (.ds-badge) with an
//          optional leading dot (and pulse for live states). Sentence-case,
//          weight 500 — a status label, not a shout. Colors come from semantic
//          tokens (success/danger/warning/primary/accent), so it swaps on theme.

import React, { forwardRef } from "react";
import { cx } from "./cx";

// --> variant → DS class. profit/loss/warn/info/neutral/accent/role.
const VARIANTS = {
  profit: "profit",
  loss: "loss",
  warn: "warn",
  warning: "warn",
  info: "info",
  neutral: "neutral",
  neut: "neutral",
  accent: "accent",
  role: "role",
};

const SIZES = { xs: "xs", sm: "sm", md: "", lg: "lg" };

export const Badge = forwardRef(function Badge(
  {
    variant = "neutral",
    tone = "soft", // soft | outline
    size = "md",
    square = false,
    mono = false,
    dot = false,
    pulse = false,
    className,
    children,
    ...props
  },
  ref
) {
  const cls = cx(
    "ds-badge",
    VARIANTS[variant] || "neutral",
    SIZES[size],
    tone === "outline" && "outline",
    square && "sq",
    mono && "mono",
    className
  );
  return (
    <span ref={ref} className={cls} {...props}>
      {dot && <span className={cx("ds-badge-dot", pulse && "pulse")} />}
      {children}
    </span>
  );
});

export default Badge;
